import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Layout } from "./components/Layout";
import { Loader } from "./components/Loader";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Catalog from "./pages/Catalog";
import Admin from "./pages/Admin";
import Impressum from "./pages/Impressum";
import Contact from "./pages/Contact";
import Datenschutz from "./pages/Datenschutz";

function App() {
  const [showLoader, setShowLoader] = useState(() => !sessionStorage.getItem("aw_loader_seen"));

  useEffect(() => {
    if (!showLoader) return;
    sessionStorage.setItem("aw_loader_seen", "1");
    const t = setTimeout(() => setShowLoader(false), 1600);
    return () => clearTimeout(t);
  }, [showLoader]);

  return (
    <div className="App">
      <LanguageProvider>
        {showLoader && <Loader />}
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/gallery" element={<Catalog />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
